import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { EmbroideryContentMobile } from './EmbroideryContentMobile'
import { EmbroideryContentDesktop, type EmbroideryContentProps } from './EmbroideryContentDesktop'

export const EmbroideryContent: React.FC<EmbroideryContentProps> = (props) => {
  const theme = useTheme()
  const isMobileUi = useMediaQuery(theme.breakpoints.down('md'))

  if (isMobileUi) {
    return <EmbroideryContentMobile {...props} />
  }

  return <EmbroideryContentDesktop {...props} />
}
